

import React, { useState, useEffect } from "react";
import "./PaymentProcess.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import cash from '../images/pngtree-cash-on-delivery-icon-png-image_6334468 2.svg'
import Loader from "../Loader";
import Group from '../images/Group 2.svg'
import empty_box2 from '../images/empty_box2.svg'


import {
  pament_addresses,
  new_addresses,
  delete_addresses,
  update_is_primary,
  payment_cod,
  payment_initialize,
  payment_methods
} from "../Redux/API";

const PaymentProcess = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
  // const [currentStep, setCurrentStep] = useState(1); // الخطوة الحالية


  const loadingPament_addresse = useSelector(state => state.Data.loadingPament_addresse);
  const loadingNew_addresses = useSelector(state => state.Data.loadingNew_addresses);
  const loadingUpdate_is_primary = useSelector(state => state.Data.loadingUpdate_is_primary);
  const loadingDelete_addresses = useSelector(state => state.Data.loadingDelete_addresses);
  const loadingPayment_cod = useSelector(state => state.Data.loadingPayment_cod);
  const pament_addresse = useSelector(state => state.Data.pament_addresses);
  const new_addresse = useSelector(state => state.Data.new_addresses);
  const update_is_primaryP = useSelector(state => state.Data.update_is_primary);
  const Payment_cods  = useSelector(state => state.Data.payment_cod );
  const errorPayment_cod  = useSelector(state => state.Data.errorPayment_cod );
  const payment_method  = useSelector(state => state.Data.payment_methods );
  const payment_initializ  = useSelector(state => state.Data.payment_initialize );
  console.log(payment_initializ)

  useEffect(() => {
    dispatch(pament_addresses()); 
  }, [dispatch, loadingNew_addresses, loadingUpdate_is_primary, loadingDelete_addresses]);

  useEffect(() => {
    dispatch(payment_methods()); 
  }, [dispatch]);

  const Delet_addresse = (id) => {
    dispatch(delete_addresses(id));
  };
  const update_is_primary_d = (id) => {
    dispatch(update_is_primary(id));
  };




  const post_payment_cod = () => {
    dispatch(payment_cod()).then((action) => {
    console.log(action)
      if ((action.payload && action.payload.status === 200)) {
        window.location.reload()
      }
    });
  };



  const [currentStep, setCurrentStep] = useState(1); // الخطوة الحالية
  const [isModalVisible, setIsModalVisible] = useState(false); // حالة عرض المودال

  const [newaddresse, setNewaddresse] = useState({
    full_name: "",
    phone_number: "",
    delivery_time: "",
    address: "",
    postal_code: "",
    is_primary: 1, // القيمة الافتراضية
  });

    // فتح نافذة المودال
    const showModal = () => {
      setNewaddresse({
        full_name: "",
        phone_number: "",
        delivery_time: "",
        address: "",
        postal_code: "",
        is_primary: 1, // القيمة الافتراضية
      });
      setIsModalVisible(true);
      setCurrentStep(null)
    };


  const savePaymentAddress = () => {
    if (
      !newaddresse.full_name ||
      !newaddresse.address ||
      !newaddresse.phone_number ||
      !newaddresse.postal_code ||
      !newaddresse.delivery_time
    ) {
      alert("Please fill in all required fields!");
      return;
    }

    dispatch(new_addresses(newaddresse));
    setIsModalVisible(false); 
    setCurrentStep(1)
  };


  const closeModal = () => {
    setIsModalVisible(false); // إخفاء المودال
    setCurrentStep(1)
  };
  const close_icon = () => {
    setIsModalVisible(false); // إخفاء المودال
    setCurrentStep(1)
  };



  




const[selectedMethod, setSelectedMethod] = useState(3)
const [paymentMethodsCard, setPaymentMethodsCard] = useState([
  {
    id: 1,
    name: t('Credit Card'), // الدفع باستخدام بطاقة ائتمان
    imageUrl: "path/to/credit-card-image.png",
  },
  {
    id: 2,
    name: t('knet'), // الدفع باستخدام PayPal
    imageUrl: "path/to/paypal-image.png",
  },
  {
    id: 3,
    name: t('cash_on_delivery'), // الدفع عند التسليم
    imageUrl: cash, // صورة للدفع عند التسليم
  },
]);

  const [showPopupMessage, setshowPopupMessage] = useState(false);

  useEffect(() => {
      if (loadingPayment_cod || errorPayment_cod) {
          setshowPopupMessage(true);
        // إخفاء الرسالة بعد 5 ثواني
        const timer = setTimeout(() => {
          setshowPopupMessage(false);
        }, 3000);
    
        return () => clearTimeout(timer); // تنظيف الـ timer عند التغيير
      }
    }, [loadingPayment_cod, errorPayment_cod]);

    const postPayment = () => {
      if (selectedMethod === 1 || selectedMethod === 2) {
        dispatch(payment_initialize({ payment_type: selectedMethod }))
          .then((action) => {
            if (action.payload && action.payload.status === 200) {
              if (selectedMethod === 1 && action.payload.data.data.direct_url) {
                // الدفع الإلكتروني: إعادة التوجيه إلى صفحة الدفع
                window.location.href = action.payload.data.data.direct_url;
              }
              if (selectedMethod === 2 && action.payload.data.data.direct_url) {
                window.location.href = action.payload.data.data.direct_url;
              }
            }
          })
          .catch((error) => {
            console.error("Error processing payment:", error);
          });
      } else{
        dispatch(payment_cod()).then((action) => {
          console.log(action)
            if ((action.payload && action.payload.status === 200)) {
              window.location.reload()
            }
          });
      }

    };
    function handelNext (){
      if(pament_addresse?.data?.data.length > 0){
        setCurrentStep(2)
      }
    }

  return (
    <div className="payment-process">
      {loadingPament_addresse && <Loader />}
      {/* الخطوة الأولى */}
      {currentStep === 1 && (
        <div className="payment-methods col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
          <div className="header">
            <button className="add-new" onClick={props.showPaymentButton}>
              {t("Close")}
            </button>
            <h3>{t("Address Book")}</h3>

            <button className="add-new" onClick={() => showModal()}>
              +
            </button>
          </div>
          <PerfectScrollbar style={{ Width: "100%", maxHeight: "80%", overflowX: "auto", overflowY: "hidden" }}>
            <>
            {pament_addresse?.data?.data.map((addresses) => (
              <div
                key={addresses.id}
                className={`payment-method ${addresses.is_primary === 1 ? "selected" : ""}`}
              >
                <div>
                  <p>
                    <strong>{addresses.address_full_name}</strong>
                    {addresses.is_primary === 1 && (
                      <span className="default-badge">
                        <FontAwesomeIcon icon={faCheck} className="mx-1" />
                        {t("Default")}
                      </span>
                    )}
                  </p>
                  <p>{addresses.address}</p>
                </div>
                <div className="actions">
                  <input
                    className="checkbox"
                    type="checkbox"
                    checked={ addresses.is_primary === 1}
                    onChange={() => update_is_primary_d(addresses.id)}
                  />

                      <button onClick={() => Delet_addresse(addresses.id)}>{t("delete_address")}</button>
                </div>
              </div>
            ))}

            {/* {(pament_addresse?.data?.data?.length === 0  || pament_addresse?.data?.data === null) && ( */}
            {(pament_addresse?.data?.data?.length === 0) && (
                <>
                    <div className="empty-cart mt-5">
                        <img src={empty_box2} alt="Empty Cart" />
                        <p>{t("add_new_address_prompt")}</p>
                        </div>
                </>
            )}
            </>
          </PerfectScrollbar>
          <button
            className={`next ${pament_addresse?.data?.data.length === 0 ? '' : 'active'}`}
            onClick={handelNext}
          >
            {t("Next")}
          </button>
        </div>
      )}

      {/* الخطوة الثانية */}
      {currentStep === 2 && (
  <div className="confirmation col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
    <div className="editingMethod">
      <i onClick={() => setCurrentStep(1)}>
        <FontAwesomeIcon icon={faChevronLeft} />
      </i>
      <p>{t("Available Payment Methods")}</p>
    </div>

    {/* خيارات طرق الدفع */}
    <div className="available-methods">
      {paymentMethodsCard.map((method) => (
        <div
          key={method.id}
          className={`payment-content ${selectedMethod === method.id ? "selected" : ""}`}
          onClick={() => setSelectedMethod(method.id)} // تحديث طريقة الدفع عند الاختيار
        >
          <div className="method-content">
            <img src={method.imageUrl} alt={method.name} className="method-image" />
            <div className="method-details">
              <p>
                <strong>{method.name}</strong>
              </p>
            </div>
            <div className="check-container">
              {selectedMethod === method.id && (
                <span className="check-icon">
                  <FontAwesomeIcon icon={faCheck} />
                </span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* زر الإنهاء */}
    <button onClick={postPayment}>{t("Done")}</button>
  </div>
)}


      {/* {currentStep === 2 && (
        <div className="confirmation col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
        {showPopupMessage && (
          <>
            {(Payment_cods?.data?.message || errorPayment_cod?.message) &&
            <div className="popup-message m-0">
              <div className="popup-conten">
              {Payment_cods?.data?.message &&
                <FontAwesomeIcon icon={faCheck} className='mx-1' />
              }
              <span>{Payment_cods?.data?.message}</span>
              <span>{errorPayment_cod?.message}</span>
              </div>
            </div>
            }
          </>
        )}
          {loadingPayment_cod && <Loader />}
          <div className="editingMethod">
            <i onClick={close_icon}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </i>
            <p>{t("Available Payment Methods")}</p>
          </div>

          <div className="available-methods">
            {paymentMethodsCard.map((method) => (
              <div
                key={method.id}
                className={`payment-content ${selectedMethod === method.id ? "selected" : ""}`}
              >
                <div className="method-content">
                  <img src={method.imageUrl} alt={method.name} className="method-image" />
                  <div className="method-details">
                    <p>
                      <strong>{method.name}</strong>
                    </p>
                  </div>
                  <div className="check-container">
                    {selectedMethod === method.id && (
                      <span className="check-icon">
                        <FontAwesomeIcon icon={faCheck} />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button onClick={post_payment_cod}>{t("Done")}</button>
        </div>
      )} */}

      {/* نافذة تعديل أو إضافة بيانات شخص */}
      {isModalVisible && (
        <div className="modal-cont col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
          <div className="editingMethod">
            <i onClick={close_icon}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </i>
            <p>{t("Add New Payment Method")}</p>
          </div>
          <label className="label">{t("Full Name")}</label>
          <input
            className="input-field"
            value={newaddresse.full_name}
            onChange={(e) => setNewaddresse({ ...newaddresse, full_name: e.target.value })}
          />
          <label className="label">{t("Phone Number")}</label>
          <input
            className="input-field"
            value={newaddresse.phone_number}
            onChange={(e) => setNewaddresse({ ...newaddresse, phone_number: e.target.value })}
          />
          <label className="label">{t("Preferred Delivery Time (optional)")}</label>
          <input
            className="input-field"
            type="date"
            value={newaddresse.delivery_time}
            onChange={(e) => setNewaddresse({ ...newaddresse, delivery_time: e.target.value })}
          />
          <label className="label">{t("Address: City / State / Street")}</label>
          <textarea
            className="textarea-field"
            value={newaddresse.address}
            onChange={(e) => setNewaddresse({ ...newaddresse, address: e.target.value })}
          />
          <label className="label">{t("Postal Code (optional)")}</label>
          <input
            className="input-field"
            value={newaddresse.postal_code}
            onChange={(e) => setNewaddresse({ ...newaddresse, postal_code: e.target.value })}
          />
          <div className="switch-container">
              <label className="switch">
              <input
                type="checkbox"
                checked={newaddresse.is_primary === 1}
                onChange={(e) =>
                  setNewaddresse({
                    ...newaddresse,
                    is_primary: e.target.checked ? 1 : 0, // تعيين القيمة بناءً على الحالة
                  })
                }
              />
              <span className="slider"></span>
            </label>
            <span className="px-2">{t("Set as Default")}</span>
          </div>
          <div className="modal-actions">
            <button className="cancel-btn" onClick={closeModal}>
              {t("Cancel")}
            </button>
            <button className="save-btn" onClick={savePaymentAddress}>
              {t("Save")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentProcess;
